import { getGraphQLClient } from "@lululemon/ecom-graphql/src/graphql-client";

const graphqlClient = getGraphQLClient();

export { graphqlClient };
